import React, { useEffect } from 'react';
import DButton from "../../Utilities/DButton"
import './notfound.css'

const NotFound = () => {
  
  useEffect(() => {
    document.title = "Page Not Found | Chai Cheng Xun";
  }, [])

  return (
    <div className='content fcc error'>
      <p className='d-text'>Page Is Not Found</p>
      <DButton text="./Return Home" to="/"/>
    </div>
  )
}

export default NotFound